import hoist from 'hoist-non-react-statics'
import PropTypes from 'prop-types'
import React from 'react'


export function withTransformer(transformer) {
  return function injectTransformedData(WrappedComponent) {
    function TransformedComponent(props) {
      const { data, ...otherProps } = props
      const transformedProps = (data && transformer) ? transformer(data, props.pageContext) : {}

      return (
        <WrappedComponent
          {...otherProps}
          {...transformedProps}
        />
      )
    }

    TransformedComponent.propTypes = {
      // eslint-disable-next-line
      data: PropTypes.object,
      // eslint-disable-next-line
      pageContext: PropTypes.object,
    }

    TransformedComponent.defaultProps = {
      data: null,
      pageContext: {},
    }

    TransformedComponent.WrappedComponent = WrappedComponent

    return hoist(TransformedComponent, WrappedComponent)
  }
}

export const getContentfulField = (data, field) => (data[field] ? data[field][field] : undefined)
